import db from '../common/localstorage'

export default {
  auth: function (id) {
    const currrent = db.get('currentMenu');
    let isHave = currrent.children.find(item => item.id == id);
    if (!isHave && currrent.id != id) {
      return false;
    } else {
      return true;
    }
  },
  authMenu: function (to) {
    const allMenus = db.get('userMenusAllMenus') || [];
    if (allMenus.length) {
      return allMenus.find(item => item.name == to.name);
    }
  }
}